/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} PlusInputs */

const en_plus = /** @type {(inputs: PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const ar_plus = /** @type {(inputs: PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const de_plus = /** @type {(inputs: PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const es_plus = /** @type {(inputs: PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const fr_plus = /** @type {(inputs: PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const it_plus = /** @type {(inputs: PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const ja_plus = /** @type {(inputs: PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const ko_plus = /** @type {(inputs: PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const pt_br_plus = /** @type {(inputs: PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const ru_plus = /** @type {(inputs: PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const th_plus = /** @type {(inputs: PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const tr_plus = /** @type {(inputs: PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const zh_cn_plus = /** @type {(inputs: PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

const zh_tw_plus = /** @type {(inputs: PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus`)
};

/**
* | output |
* | --- |
* | "Plus" |
*
* @param {PlusInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const plus = /** @type {((inputs?: PlusInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<PlusInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plus(inputs)
	if (locale === "ar") return ar_plus(inputs)
	if (locale === "de") return de_plus(inputs)
	if (locale === "es") return es_plus(inputs)
	if (locale === "fr") return fr_plus(inputs)
	if (locale === "it") return it_plus(inputs)
	if (locale === "ja") return ja_plus(inputs)
	if (locale === "ko") return ko_plus(inputs)
	if (locale === "pt_br") return pt_br_plus(inputs)
	if (locale === "ru") return ru_plus(inputs)
	if (locale === "th") return th_plus(inputs)
	if (locale === "tr") return tr_plus(inputs)
	if (locale === "zh_cn") return zh_cn_plus(inputs)
	return zh_tw_plus(inputs)
});